"use client";

import { useState, useEffect } from "react";

export default function WhatsAppButton() {
  const [isReady, setIsReady] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  // Obfuscate phone number and only construct it client-side after mount
  useEffect(() => {
    // Split the number into parts to avoid direct scraping
    const parts = ["44", "7405", "503", "752"];
    setPhoneNumber(parts.join(""));

    // Small delay to prevent automated clicks
    setTimeout(() => setIsReady(true), 1000);
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    if (!isReady) {
      e.preventDefault();
      return;
    }

    // Add a pre-filled message to identify source and deter bots
    const message = encodeURIComponent(
      "Hello! I'm interested in learning more about your weight loss services. I found you through ukweightloss.co.uk"
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    // Open in new window
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    e.preventDefault();
  };

  // Don't render until client-side mounted and ready
  if (!phoneNumber) return null;

  return (
    <button
      onClick={handleClick}
      disabled={!isReady}
      className={`fixed bottom-6 right-6 z-50 group ${
        !isReady ? "opacity-50 cursor-not-allowed" : ""
      }`}
      aria-label="Contact us on WhatsApp"
    >
      <div className="relative">
        {/* Pulsing ring effect */}
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-75"></div>

        {/* Main button */}
        <div className="relative w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#20BA5A] rounded-full shadow-lg hover:shadow-2xl flex items-center justify-center transition-all duration-300 transform hover:scale-110">
          {/* WhatsApp Icon */}
          <svg
            className="w-8 h-8 sm:w-9 sm:h-9 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
        </div>

        {/* Tooltip */}
        <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <div className="bg-gray-900 text-white text-sm font-medium px-4 py-2 rounded-lg shadow-xl whitespace-nowrap">
            Chat with us on WhatsApp
            <div className="absolute top-full right-6 -mt-1">
              <div className="border-8 border-transparent border-t-gray-900"></div>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}
